import { apiFetcher } from '~/apis/api-fetcher';

import { ProductV2Response } from './models';

export type ProductParams = {
  pid: number;
  include?: Array<string>;
  allowDeleted?: boolean;
  buyerUid?: number;
  priceOfferId?: number;
};

/** 상품 단건 조회 */
export const getProduct = ({ pid, ...params }: ProductParams, requestInit?: RequestInit) =>
  apiFetcher.get<ProductV2Response>(`/api/pms/v2/products/${pid}`, params, requestInit);
